var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('span',{staticClass:"mini-user-display"},[_c('img',{staticClass:"mini-user-profile-image",attrs:{"src":_vm.user.profile_image_url}}),_vm._v(" "),_c('span',{staticClass:"mini-user-name"},[_vm._v(_vm._s(_vm.user.display_name))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c711bad8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = Mneh
// module chunks = 1